import { FormArray } from '@angular/forms';

export class FormArrayUtils {

  static clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

}
